export const deleteFolderCopy = {
  folderHeader: '',
  subFolderHeader: '',
  description: '',
  successToast: '',
};
